import store from './index';
import { SubscribeQuery } from '../queries';
import SocketService from '../services/SocketService';
import ChatService from '../services/ChatService';
import { Chat } from '../models';

export interface ChatState {
  chatSubscribeId: number;
  selectedChat: Chat;
  chats: Chat[];
  counters: {
    running: number
    waiting: number
    teams: {
      [id: string]: number,
    }
    users: {
      [id: string]: number,
    },
  };
  loading: boolean;
}

export const ChatModule = {
  state: {
    chatSubscribeId: 0,
    selectedChat: null,
    chats: [],
    counters: {
      running: 0,
      waiting: 0,
      teams: {},
      users: {},
    },
    loading: false,
  },
  mutations: {
    setChats(state: ChatState, chats: Chat[]) {
      state.chats = chats;
    },
    setChatSubscribeId(state: ChatState, id: number) {
      state.chatSubscribeId = id;
    },
    setSelectedChat(state: ChatState, chat: Chat) {
      state.selectedChat = { ...chat };
      store.dispatch('loadMessages', chat.objectId);
    },
    onChatCreate(state: ChatState, chat: Chat) {
      console.log('callback', chat);
    },
    setChatLoading(state: ChatState, loading: boolean) {
      state.loading = loading;
    },
  },
  actions: {
    unsubscribeChat() {
      if (store.state.chat.chatSubscribeId) {
        SocketService.unsubscribe(store.state.chat.chatSubscribeId);
      }
    },
    async loadChat(context: any, chatId: string) {
      const chat = await ChatService.getChatById(chatId);
      context.commit('setSelectedChat', chat);
    },
    async loadChatByChatId(context: any, chatId: string) {
      const chat = await ChatService.getChatByChatId(chatId);
      if (chat) {
        context.commit('setSelectedChat', chat);
      }
    },
    async loadChatsByTab(context: any, tab: any) {
      context.dispatch('unsubscribeChat');
      context.dispatch('unsubscribeMessages');
      context.commit('setChatLoading', true);
      context.commit('setChats', []);
      const chats = await ChatService.getChatsByTab(tab);
      context.commit('setChats', chats);
      context.commit('setChatLoading', false);
      const query = ChatService.getQuery(tab) as SubscribeQuery;
      if (!query) { return; }
      const subId = await SocketService.subscribe({
        query: { where: query.where, className: query.className },
        events: {
          create: 'onChatCreate',
          leave: 'onChatCreate',
          update: 'onChatCreate',
        },
      });
      context.commit('setChatSubscribeId', subId);
    },
  },
};
